module.exports = __webpack_public_path__ + "static/media/abrc-banner.974523e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/abrc-banner.png
// module id = 599
// module chunks = 0